var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActiveTodo = function SvgActiveTodo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "14.027%",
    y1: "-54.318%",
    x2: "88.304%",
    y2: "147.336%",
    id: "ActiveTodo_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FBC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BA88",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5.293V.5a.5.5 0 0 0-.5-.5H8a.5.5 0 0 0-.326.879L11 3.73v1.563l-4.5 4.5-2.146-2.146a.5.5 0 0 0-.707 0l-3.5 3.5A.498.498 0 0 0 0 11.5v2a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-6a.498.498 0 0 0-.147-.354L12 5.293Z",
    stroke: "#FFF",
    strokeWidth: 0.2,
    fill: "#006E50",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.622 1H10.9a.1.1 0 0 1 .1.1v1.096a.1.1 0 0 1-.165.076L9.557 1.176A.1.1 0 0 1 9.622 1ZM12.7 13H1.3a.3.3 0 0 1-.3-.3v-.579a1 1 0 0 1 .293-.707L3.788 8.92a.3.3 0 0 1 .424 0l1.935 1.934a.5.5 0 0 0 .707 0l4.434-4.434a.3.3 0 0 1 .424 0l.995.995a1 1 0 0 1 .293.707V12.7a.3.3 0 0 1-.3.3Z",
    fill: "url(#ActiveTodo_svg__a)"
  }))));
};
export default SvgActiveTodo;